import React, { useEffect, useState } from "react";
import VerticalPoints from "../Common/VerticalPoints/VerticalPoints";
import { useDispatch, useSelector } from "react-redux";
import { openRightModal } from "../../REDUX/actions/rightModal";
import ModifyOrder from "./ModifyOrder/ModifyOrder";
import OrderProductsList from "../Common/OrderProductsList/OrderProductsList";
import { openCenteredModal } from "../../REDUX/actions/centeredModal";
import DeleteCommand from "./DeleteCommand";
import DeliveryDialog from "./DeliveryDialog/DeliveryDialog";
import ModifyStatusDialog from "./ModifyOrder/ModifyStatusDialog";
// import CommandeStatusTag from "./CommandeStatusTag";
import { saveAs } from "file-saver";
import { IMAGE_END_POINT } from "../../Api/EndPoints";
import { formatDate, handleDownload } from "../../Utils/fileUtils";
import adjustPrice from "../../Utils/AdjustPrice";
import CustomTooltip from "../Common/CustomTooltip/CustomTooltip";
import {
  generateAvoir,
  generateBonDeCommande,
} from "../../REDUX/actions/catalogue";
import { useNavigate } from "react-router-dom";
import {
  updateCommande,
  updatePreviousValues,
  sendDepositMail,
  sendFullPaymentMail,
  sendBalanceMail,
} from "../../REDUX/actions/commandes";
import { useTranslation } from "react-i18next";
import { addCurrentAvoir, createAvoir } from "../../REDUX/actions/avoir";
import useCanSeePrices from "../../hooks/useCanSeePrices";

const OrderCardAdmin = ({ commande }) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const [depositFiles, setDepositFiles] = useState();
  const [show, setShow] = useState(false);
  const [mailLoading, setMailLoading] = useState(null);

  const handleSendMail = async (type, action) => {
    setMailLoading(type);
    await dispatch(action);
    setMailLoading(null);
  };

  const { userRole, user } = useSelector((state) => state.userReducer);
  // A store's commercial: no amount, no priced document, no payment.
  const canSeePrices = useCanSeePrices();
  const { factureLoading, avoirLoading } = useSelector(
    (state) => state.commandeReducer,
  );

  const sumPaiements = commande?.payments?.reduce(
    (acc, { amount }) => acc + +amount,
    0,
  );

  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(
      openCenteredModal(
        <DeleteCommand
          commandeNumber={commande.number}
          commandeId={commande.id}
        />,
      ),
    );
  };

  const handleDeliveryDate = (isEstimatedDate) => {
    dispatch(
      openCenteredModal(
        <DeliveryDialog
          estimatedDeliveryDate={commande?.estimatedDeliveryDate}
          realDeliveryDate={commande?.realDeliveryDate}
          orderStatus={commande?.status}
          orderId={commande?.id}
          orderNumber={commande?.number}
          isEstimatedDate={isEstimatedDate}
          deliveryType={commande?.delivery_type?.name}
          entrepot={commande}
        />,
      ),
    );
  };

  useEffect(() => {
    if (commande?.payments?.length <= 0) {
      setDepositFiles([]);
    } else {
      setDepositFiles(
        commande?.payments?.map((item) => ({
          invoiceSlug: item?.acompte_facture?.number,
          orderSlug: commande?.number,
          fileUrl: item?.acompte_facture?.media?.url,
        })),
      );
    }
  }, [commande?.payments, commande?.number]);

  const bgClassName = show ? "bg-blue" : "";
  const textColorClassName = show ? "text-white" : "text-brightGrey";
  const showClassName = show ? "show" : "";

  // No payments for a commercial (the API strips them).
  const totalAcompteFactures = (commande.payments ?? []).reduce((sum, payment) => {
    return sum + (payment.acompte_facture ? 1 : 0);
  }, 0);

  return (
    <div>
      <div
        className={`orderCardAdmin ${
          commande?.majorAccountOrder && !show && "bg-lightYelloww"
        } border-bottom row p-4 d-flex justify-content-between pointer align-items-center w-100 orderCardContainer ${bgClassName} ${showClassName}`}
        onClick={() => setShow((prev) => !prev)}
      >
        <CustomTooltip title={t("#New|Old")}>
          <div
            className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
          >
            #{commande.number}
            {commande?.oldId && `|${commande?.oldId}`}
          </div>
        </CustomTooltip>

        <div
          className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
        >
          {commande.date ? formatDate(commande.date, "DD-MM-YYYY") : "-"}
        </div>

        <CustomTooltip title={t("Invoice number / Billing date")}>
          <div
            className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
          >
            <span>
              #
              {commande?.credit
                ? commande?.avoir?.number
                : commande.facture?.number || ""}
            </span>
            <br />
            <span>
              {commande?.credit
                ? commande?.avoir?.date
                : commande.facture?.date || ""}
            </span>
          </div>
        </CustomTooltip>
        <CustomTooltip
          title={commande.reseller?.name || commande.particulierName}
        >
          <div
            className={`f14 text-brightGrey normal col-1 ${textColorClassName} ellipsis-text`}
          >
            {/* A store's order for a client project ("Passer la commande"). */}
            {commande.project ? (
              <>
                {commande.reseller?.name || commande.particulierName || "-"}
                <span
                  className="d-inline-block f11 sBold px-2 mt-1 br10"
                  style={{ color: "#14748e", background: "#e7f2f5" }}
                >
                  {t("Project No. {{number}}", {
                    number: commande.project.number ?? commande.project.id,
                  })}
                </span>
              </>
            ) : (
              commande.reseller?.name || commande.particulierName || "-"
            )}
          </div>
        </CustomTooltip>
        {!commande?.credit && (
          <div
            className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
          >
            <span>#{commande.bon_de_commande?.number || ""}</span>
            <br />
            <span>{commande.bon_de_commande?.date || ""}</span>
          </div>
        )}

        <CustomTooltip title={t("Estimated delivery / Delivery")}>
          <div
            className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
          >
            {commande.estimatedDeliveryDate
              ? formatDate(commande.estimatedDeliveryDate, "DD-MM-YYYY")
              : "-"}{" "}
            <br />
            {commande.realDeliveryDate
              ? formatDate(commande.realDeliveryDate, "DD-MM-YYYY")
              : "-"}
          </div>
        </CustomTooltip>

        <div
          className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
        >
          {userRole === "BusinessBroker"
            ? commande.comission
              ? `${commande.comission} €`
              : "-"
            : commande.business_affiliate
              ? `${commande.business_affiliate?.user?.firstName}`
              : "-"}
        </div>
        {userRole === "admin" && (
          <div
            className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
          >
            {commande?.txMarge
              ? `${commande?.txMarge?.toFixed(2)?.toString()} %`
              : "-"}
          </div>
        )}

        <div
          className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
        >
          {canSeePrices
            ? `${adjustPrice(commande.totalTTC?.toFixed(2)?.toString())} €`
            : "-"}
        </div>
        {commande.status === "Brouillon" && userRole === "admin" ? (
          <CustomTooltip
            title={`${t("Being modified by")} ${
              commande.ongoingCreator?.firstName || ""
            } ${commande.ongoingCreator?.lastName || ""}`}
          >
            <div
              className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
            >
              {t(`${commande.status ?? ""}`)}
            </div>
          </CustomTooltip>
        ) : (
          <div
            className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
          >
            {t(`${commande.status ?? ""}`)}
          </div>
        )}
        <div
          className={`f14 text-brightGrey normal col-1 ${textColorClassName}`}
        >
          {t(`${commande.payStatus ?? ""}`)}
        </div>
        <div
          className={`f14 text-brightGrey normal d-flex align-items-center justify-content-around col-1 ${textColorClassName}`}
        >
          {commande.creator?.firstName || "-"}
          <div
            className={`f14 normal  col-1 ${textColorClassName}alignH justify-content-between`}
          >
            <VerticalPoints
              showLeft
              options={[
                {
                  text: t("View the order"),
                  callback: () =>
                    dispatch(
                      openRightModal(
                        <ModifyOrder
                          id={commande?.id}
                          initialTab={"General information"}
                        />,
                      ),
                    ),
                },
                {
                  text: t("Modify the order"),
                  hidden: userRole !== "admin",
                  callback: () => {
                    localStorage.setItem("selectedCart", commande.id);
                    dispatch(
                      updatePreviousValues(
                        commande?.packings?.map((packing) => packing.id),
                        commande?.deliveryPrice,
                        commande.id,
                      ),
                    );
                    dispatch(
                      updateCommande(commande.id, {
                        status: "Brouillon",
                        ongoingCreator: user.id,
                      }),
                    ).then(() => navigate("/catalogue"));
                  },
                },
                {
                  text: t("Mail Acompte"),
                  hidden:
                    userRole !== "admin" ||
                    commande.status === "Brouillon" ||
                    commande.payStatus !== "En attente",
                  loading: mailLoading === "deposit",
                  callback: () =>
                    handleSendMail("deposit", sendDepositMail(commande.id, t)),
                },
                {
                  text: t("Mail Total Liv"),
                  hidden:
                    userRole !== "admin" ||
                    commande.status === "Brouillon" ||
                    commande.payStatus !== "En attente",
                  loading: mailLoading === "fullPayment",
                  callback: () =>
                    handleSendMail(
                      "fullPayment",
                      sendFullPaymentMail(commande.id, t),
                    ),
                },
                {
                  text: t("Mail Solde Liv"),
                  hidden:
                    userRole !== "admin" ||
                    commande.status === "Brouillon" ||
                    commande.payStatus !== "Acompte payé",
                  loading: mailLoading === "balance",
                  callback: () =>
                    handleSendMail("balance", sendBalanceMail(commande.id, t)),
                },
                {
                  text: t(
                    // commande?.payStatus &&
                    //   +sumPaiements === +commande?.totalTTC &&
                    "Download invoice",
                    // : "Download balance invoice"
                  ),
                  hidden:
                    !canSeePrices ||
                    !commande?.facture?.media?.url ||
                    commande?.credit ||
                    !commande?.payStatus ||
                    +sumPaiements !== +commande?.totalTTC?.toFixed(2),
                  callback: () =>
                    saveAs(
                      IMAGE_END_POINT + commande?.facture?.media?.url,
                      `${t("Invoice")}-${commande.facture?.number} ${t(
                        "Order",
                      )}-${commande.number}`,
                    ),
                },
                // {
                //   text: t(
                //     // commande?.payStatus &&
                //     //   +sumPaiements === +commande?.totalTTC &&
                //     "Generate the invoice"
                //     // : "Generate the balance invoice"
                //   ),
                //   hidden:
                //     userRole !== "admin" ||
                //     commande.status === "Brouillon" ||
                //     commande?.credit ||
                //     !commande?.payStatus ||
                //     +sumPaiements !== +commande?.totalTTC,
                //   loading: factureLoading === commande.id,

                //   callback: () =>
                //     dispatch(generateInvoice(commande.id, true, t)),
                // },

                {
                  text: t("Generate the credit"),
                  hidden:
                    userRole !== "admin" ||
                    commande.status === "Brouillon" ||
                    !commande?.credit,
                  loading: avoirLoading === commande.id,

                  callback: () => dispatch(generateAvoir(commande.id, true, t)),
                },

                {
                  text: t("Download credit"),
                  hidden: !canSeePrices || !commande?.avoir?.media?.url || !commande?.credit,
                  callback: () =>
                    saveAs(
                      IMAGE_END_POINT + commande?.avoir?.media?.url,
                      `${t("Credit")}-${commande.avoir?.number} ${t("Order")}-${
                        commande.number
                      }`,
                    ),
                },

                {
                  text: t("Download the purchase order"),
                  hidden:
                    !canSeePrices ||
                    !commande?.bon_de_commande?.media?.url ||
                    commande?.credit,
                  callback: () =>
                    saveAs(
                      IMAGE_END_POINT + commande?.bon_de_commande?.media?.url,
                      `Bon_de_commande-${commande.bon_de_commande?.number}-commande-${commande.number}`,
                    ),
                },
                {
                  text: t("Generate the purchase order"),
                  hidden: userRole !== "admin" || commande?.credit,
                  loading: factureLoading === commande.id,

                  callback: () =>
                    dispatch(generateBonDeCommande(commande.id, true, t)),
                },
                // {
                //   text: "Générer la facture",
                //   // hidden: !!!orderData?.attachment?.file?.url,
                //   callback: () =>
                //     dispatch(
                //       generateInvoice(commande.id)
                //     ),
                //   loading: invoicesLoading,
                // },
                // {
                //   text: "Préparation de livraison",
                //   callback: handleOpenDeliverySummary,
                // },
                {
                  text: t("Download deposit invoices"),
                  hidden:
                    // userRole !== "admin" ||
                    !canSeePrices ||
                    commande.status === "Brouillon" ||
                    totalAcompteFactures <= 0,
                  callback: () => handleDownload(depositFiles),
                },
                {
                  text: t("Set an estimated delivery date"),
                  hidden: userRole === "commercial",
                  callback: () => handleDeliveryDate({ isEstimatedDate: true }),
                },
                {
                  text: t("Arrange the delivery"),
                  hidden: [0, 7].includes(user?.attributes?.userRole),
                  callback: () => handleDeliveryDate(),
                },
                {
                  text: t("Comment"),
                  hidden: userRole === "commercial",
                  callback: () =>
                    dispatch(
                      openRightModal(
                        <ModifyOrder
                          id={commande?.id}
                          initialTab={"Comments"}
                        />,
                      ),
                    ),
                },
                {
                  text: t("Deposits and payments"),
                  hidden: !canSeePrices,
                  callback: () =>
                    dispatch(
                      openRightModal(
                        <ModifyOrder
                          id={commande?.id}
                          initialTab={"Payments"}
                        />,
                      ),
                    ),
                },

                {
                  text: commande?.avoir
                    ? t("Modify the credit")
                    : t("Create a credit"),
                  // hidden: !commande.facture?.number,
                  hidden: !commande.facture?.number,
                  callback: () => {
                    if (commande?.avoir) {
                      dispatch(
                        addCurrentAvoir(
                          commande?.avoir?.id,
                          commande?.avoir?.state,
                          () =>
                            navigate("/avoirs/editer", {
                              state: { id: commande?.avoir?.id },
                            }),
                        ),
                      );
                    } else {
                      dispatch(
                        createAvoir(
                          commande,
                          (state) => navigate("/avoirs/editer", { state }),
                          t,
                        ),
                      );
                    }
                  },
                },
                {
                  text: t("Set status"),
                  hidden: userRole !== "admin",
                  callback: () =>
                    dispatch(
                      openCenteredModal(
                        <ModifyStatusDialog
                          id={commande.id}
                          status={commande.status}
                          number={commande?.number}
                          packings={commande?.packings?.map(
                            (packing) => packing.id,
                          )}
                        />,
                      ),
                    ),
                },

                {
                  text: t("Set payment status"),
                  hidden: userRole !== "admin",
                  callback: () =>
                    dispatch(
                      openCenteredModal(
                        <ModifyStatusDialog
                          id={commande.id}
                          status={commande.payStatus}
                          number={commande?.number}
                          isPayment
                        />,
                      ),
                    ),
                },
                // {
                //   text: !paymentStatus
                //     ? "Valider le paiement"
                //     : "Annuler le paiement",
                //   callback: handlePayment,
                // },
                {
                  text: t("Delete the order"),
                  hidden:
                    userRole !== "admin" ||
                    commande.status === "Livrée" ||
                    commande.payStatus === "Payée" ||
                    commande.payStatus === "Acompte payé",
                  callback: handleDelete,
                  red: true,
                },
              ]}
              color={show ? "white" : ""}
              className="ms-auto"
            />
          </div>
        </div>
      </div>

      {show && <OrderProductsList orderData={commande} />}
    </div>
  );
};

export default OrderCardAdmin;
